import { Partition } from "Models/partition";

export const getPartitions = (state: any): Partition[] => state.partitions;
export const getPartition = (logUid: string) => (state: any): Partition =>
    state.partitions?.find((p: Partition) => p.logUid === logUid);
